// import {createRef, useContext} from "react";
//import {useDropzone} from 'react-dropzone';
// import fileDownload from "js-file-download";
import { UPGRADE_API } from "../vars";
import { showDangerToast, showInfoToast, showSuccessToast } from "../validation/ToastContainer";
import { getAuthHeader, securedFetch } from "../auth/authService";
// import {TableContext} from "../index";

export async function downloadFilesBackup() {

    /*  const filename = new Date().toISOString() + '_files.zip'
 
     const token = localStorage.getItem('access_token');
 
     return fetch(`${BACKUP_API}/files?_ticket=${token}`)
         .then(async res => {
             const response = await res.blob();
 
             if (!res.ok) {
                 return null
             }
 
             fileSaver.saveAs(response, filename);
             return true;
         }) */

}

//Works only in production mode (routing)
export async function downloadBackup() {
    /* const filename = new Date().toISOString() + '_backup.sql'

    const token = localStorage.getItem('access_token');

    const serverResponse = await fetch(`${BACKUP_API}?_ticket=${token}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        }
    });

    const responseJson = await serverResponse.json();
    if (!serverResponse.ok) {
        return false
    }
    const fileNameToDownload = responseJson.fileName;
    const link = document.createElement("a");
    link.download = filename;
    link.href = BACKUP_API + `/download/${fileNameToDownload}?_ticket=${token}`;
    link.click();
    return true; */
}

export async function applyDump(file) {
    /*  showInfoToast("Starting system restoring", "Restore System", '', true)
     const formData = new FormData();
     formData.append("dump", file);
     return fetch(`${BACKUP_API}`,
         {
             method: 'POST',
             headers: {
                 ...getAuthHeader()
             },
             body: formData
         }).then(async response => {
         if (!response.ok) {
             const json = await response.json();
             showDangerToast(`${json.message || 'Something went wrong'}`, `Error ${response.status}`, 'Check that the dump is not corrupted')
         } else {
             showSuccessToast('Application data was restored', 'Restore System')
         }
 
         return response.ok;
     }) */
}



/*export function uploadfile() {

     showInfoToast("Starting uploading Application New Files", "Application New Version", '', true)
    
    const {getRootProps, getInputProps, open, acceptedFiles} = useDropzone({
        // Disable click and keydown behavior
         noClick: true,
        noKeyboard: true
      });
    
      const files = acceptedFiles.map(file => (
        <li key={file.path}>
          {file.path} - {file.size} bytes
        </li>
      ));
    
      return (
        <div className="container">
          <div {...getRootProps({className: 'dropzone'})}>
            <input {...getInputProps()} />
            <p>Drag 'n' drop some files here</p>
            <button type="button" onClick={open}>
              Open File Dialog
            </button>
          </div>
          <aside>
            <h4>Files</h4>
            <ul>{files}</ul>
          </aside>
        </div>
      );  
    
    
      //const filename = new Date().toISOString() + '_files.zip'

     var fileSelector = document.createElement('input');
    fileSelector.setAttribute('type', 'file');
    
    var selectDialogueLink = document.createElement('a');
    selectDialogueLink.setAttribute('href', '');
    selectDialogueLink.innerText = "Select File";
    
    selectDialogueLink.onclick = function () {
         fileSelector.click();
         return false;
    } 

} */

export async function uploadfile() {
    showInfoToast("Start uploading Application New Files", "Application New Version", '', true)
    //const formData = new FormData();
    //formData.append("file", file);
    /* return fetch(`${RULE_API}/import`,
        {
            method: 'POST',
            headers: {
                ...getAuthHeader()
            },
            body: formData
        }).then(async response => {

        if (!response.ok) {
            const json = await response.json();
            showDangerToast(`${json.message || 'Something went wrong'}`, `Error ${response.status}`, 'Check that the data is correct')
        } else {
            showSuccessToast('Rules were uploaded', 'Import Rules')
        } 

        
    }) */
    //buildFileSelector(); 


    // const ref = createRef();
    // const {config, setConfig} = useContext(TableContext);

    // const onChange = (event) => {
    //     const file = event.target.files[0];
    //      /* importXlsxRules(file).then(result => {
    //         event.target.type = '';
    //         event.target.type = 'file';
    //         if (result) {
    //             setConfig({...config, lastUpdated: Date.now()})
    //         } 
    //     }); */
    // }

}

//DevTeam Mar 01, 2022: Upload the upgraded Source Code to the customer Octopus Server
export async function prepareEnvForUpgrade(file) {
    try {
        const formData = new FormData();
        formData.append("file", file);

        const response = await fetch(`${UPGRADE_API}/prepareupgrade`, {
            method: 'POST',
            headers: {
                ...getAuthHeader()
            },
            body: formData
        });

        if (!response.ok) {
            const json = await response.json();
            showDangerToast(`${json.message || 'Upgrade Preparation has issues'}`, `Error ${response.status}`, 'Please Contact the Administrator!');
        } else {
            showSuccessToast('Upgrade Files are now Prepared', 'Prepare Upgrade');
        }

        return response.ok;
    } catch (error) {
        console.error("Error while preparing upgrade:", error);
        throw error;
    }
}

export async function startUpgrade() {
    try {
        const response = await fetch(`${UPGRADE_API}/startupgrade`, {
            method: 'POST',
            headers: {
                ...getAuthHeader()
                //body: formData
            },
        });

        if (!response.ok) {
            //'POST')
            //.then(response => response.json());
            const json = await response.json();
            showDangerToast(`${json.message || 'Something went wrong'}`, `Error ${response.status}`, 'Check that the data is correct');
        } else {
            showSuccessToast('Octopus VAR App Upgrade is Complete', ' Upgrade');
        }

        return response.ok;
    } catch (error) {
        console.error("Error while starting upgrade:", error);
        throw error;
    }
}

export async function testing() {
    try {
        const response = await securedFetch(`${UPGRADE_API}/test`, null, 'GET');

        if (!response.ok) {
            const json = await response.json();
            showDangerToast(`${json.message || 'Test has issues'}`, `Error ${response.status}`, 'Please DG Contact the Administrator!');
        } else {
            showSuccessToast('Test -3 is Successful', 'Prepare Upgrade');
        }

        return response.ok;
    } catch (error) {
        console.error("Error while testing upgrade:", error);
        throw error;
    }
}

